import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DataGrid, { Column, Editing, Paging } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef, EmptyItem } from "devextreme-react/form";
import IDroitAcces from "../../models/IDroitAcces";
import Guid from "../../models/Guid";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useApi from '../../hooks/useApi';

interface IGestionPermissionProps {
  isModeSelection?: boolean,
}

export default function GestionPermission({ isModeSelection }: IGestionPermissionProps) {
  const droitAccesFormDataSource = useCustomDataSource<IDroitAcces, IDroitAcces>({ path: "droitacces", primaryKey: "idDroitAcces", customSauvegarderPath: "droitacces/save" });
  const { selectedDataRow: selectedDroitAcces, mode, setMainForm, setSelectedDataRow, setMode, onFieldDataChanged, isFieldModifier, setIsFieldModifier } = droitAccesFormDataSource;
  const formRef = useRef<FormRef>(null);
  const { getData } = useApi<object>();
  const [DataPermissionGestionnaires, setPermissionGestionnaires] = useState<any[]>([]);
  const [DataPermissionRapports, setPermissionRapports] = useState<any[]>([]);
  const [DataPermissionAutres, setPermissionAutres] = useState<any[]>([]);


  useEffect(() => {
    setMainForm(formRef.current?.instance());
  });

  useEffect(() => {
    if (selectedDroitAcces.idDroitAcces)
      _loadData(selectedDroitAcces?.idDroitAcces);
    if (mode !== Mode.Lecture)
      formRef.current?.instance().getEditor("description")?.focus();
  }, [selectedDroitAcces?.idDroitAcces, mode]);

  const { actifOptions, miseAJourOptions, spinEditorOptions } = useMemo(() => {
    return {
      actifOptions: { text: "Actif" },
      miseAJourOptions: { text: "Permettre la mise à jour du logiciel" },
      spinEditorOptions: { min: 0, max: 100, showSpinButtons: true, width: '100px' },
    };
  }, []);

  const _loadFacture = useCallback(async (IdDroitAccesDetails: Guid) => {
    const results = await getData({ customPath: `droitacces/${IdDroitAccesDetails}/permissions` });
    const resultArray = Object.values(results);
    const _permissionGestionnaires: any[] = [];
    const _permissionRapports: any[] = [];
    const _permissionAutres: any[] = [];

    resultArray.map(e => {
      if (e.type === "DEF") {
        _permissionGestionnaires.push(e);
      } else if (e.type === "RAP") {
        _permissionRapports.push(e);
      } else if (e.type === "AUT") {
        _permissionAutres.push(e);
      }
    });
    setSelectedDataRow((prev) => {
      return {
        ...prev,
        droitAccesDetails: resultArray,
        // droitAccesDetail: [...prev?.droitAccesDetails || [], resultArray],
      } as IDroitAcces
    });
    setPermissionGestionnaires(_permissionGestionnaires as any[]);
    setPermissionRapports(_permissionRapports as any[]);
    setPermissionAutres(_permissionAutres as any[]);
  }, [getData]);

  const _loadData = useCallback(async (IdDroitAccesDetails: Guid) => {
    if (isModeSelection) return;

    await Promise.all([
      _loadFacture(IdDroitAccesDetails),
    ]);
  }, [_loadFacture]);

  const onCellClick = (e: any) => {


    const index = selectedDroitAcces.droitAccesDetails.findIndex(
      item => item.idDroitAccesDetail?.equals(e.key)
    );

    const copy = selectedDroitAcces.droitAccesDetails;
    copy[index].gerer = e.values[1];
    // copy[index].gerer = e.gerer;
    copy[index].consulter = e.values[2];
    // copy[index].consulter = e.consulter;
    // console.log(copy[index])
    setSelectedDataRow((prev) => {
      return {
        ...prev,
        droitAccesDetails: copy,
      } as IDroitAcces
    });
    setIsFieldModifier(true);
  }

  // console.log(DataPermissionGestionnaires)
  // console.log(DataPermissionRapports)
  // console.log(selectedDroitAcces)
  return (
    <FormListBase data={droitAccesFormDataSource}>
      <FormListBaseGrid
        dataSource={droitAccesFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture);
          }
        }}
      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedDroitAcces?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem colCount={3} alignItemLabels={false}>
                <SimpleItem
                  key={"frm-description"}
                  dataField={"description"}
                // editorOptions={{ width: 225 }}
                />
                <SimpleItem
                  key={"frm-actif"}
                  dataField={"actif"}
                  editorType={"dxCheckBox"}
                  editorOptions={actifOptions}
                >
                  <Label visible={false} />
                </SimpleItem>
                <EmptyItem />
              </GroupItem>
              <GroupItem colCount={2}>
                <GroupItem caption={"Permissions des gestionnaires"} colSpan={1}>
                  <DataGrid
                    showBorders={true}
                    allowColumnResizing={true}
                    onCellClick={onCellClick}
                    dataSource={DataPermissionGestionnaires}
                    keyExpr="idDroitAccesDetail"
                  >
                    <Editing
                      mode="cell"
                      allowUpdating={mode !== Mode.Lecture}
                    />
                    <Paging enabled={false} />
                    <Column dataField="description" caption={"Gestionnaire"} />
                    <Column caption={"Gérer"} width={'15%'}
                      dataField="gerer"
                      dataType="boolean" />
                    <Column caption={"Consulter"} width={'15%'}
                      dataField="consulter"
                      dataType="boolean" />
                  </DataGrid>
                </GroupItem>
                <GroupItem caption={"Permissions de rapports"} colSpan={1}>
                  <DataGrid
                    showBorders={true}
                    allowColumnResizing={true}
                    onCellClick={onCellClick}
                    dataSource={DataPermissionRapports}
                    keyExpr="idDroitAccesDetail"
                  >
                    <Editing
                      mode="cell"
                      allowUpdating={true}
                    />
                    <Paging enabled={false} />
                    <Column dataField="description" caption={"Rapport"} />
                    <Column dataField="consulter" caption={"Consulter"} />
                  </DataGrid>
                </GroupItem>
              </GroupItem>
            </Form>
          </TabItem>

          {/* [ */}
          {/* {
            "idDroitAccesDetail": "99443d2c-ae96-ea11-b889-80c5f260a79c",
          "idDroitAcces": "94443d2c-ae96-ea11-b889-80c5f260a79c",
          "description": "afficher_ventilation",
          "gerer": true,
          "consulter": true,
          "flag": 0,
          "type": "AUT",
          "dateCreation": "2020-05-15T13:15:40.000Z",
          "dateModification": "2023-03-10T15:29:58.000Z",
          "dateSuppression": null,
          "idUsagerCreation": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerModification": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerSuppression": null,
          "isDeleted": false
    }, */}
          {/* {
            "idDroitAccesDetail": "f7443d2c-ae96-ea11-b889-80c5f260a79c",
          "idDroitAcces": "94443d2c-ae96-ea11-b889-80c5f260a79c",
          "description": "facturation_obligatoire_enregistrement",
          "gerer": true,
          "consulter": true,
          "flag": 0,
          "type": "AUT",
          "dateCreation": "2020-05-15T13:15:41.000Z",
          "dateModification": "2023-03-10T15:29:58.000Z",
          "dateSuppression": null,
          "idUsagerCreation": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerModification": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerSuppression": null,
          "isDeleted": false
    }, */}
          {/* {
            "idDroitAccesDetail": "a7443d2c-ae96-ea11-b889-80c5f260a79c",
          "idDroitAcces": "94443d2c-ae96-ea11-b889-80c5f260a79c",
          "description": "modifier_facture_paiement_maj",
          "gerer": false,
          "consulter": true,
          "flag": 0,
          "type": "AUT",
          "dateCreation": "2020-05-15T13:15:40.000Z",
          "dateModification": "2023-03-10T15:29:58.000Z",
          "dateSuppression": null,
          "idUsagerCreation": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerModification": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerSuppression": null,
          "isDeleted": false
    }, */}
          {/* {
            "idDroitAccesDetail": "3b453d2c-ae96-ea11-b889-80c5f260a79c",
          "idDroitAcces": "94443d2c-ae96-ea11-b889-80c5f260a79c",
          "description": "paiements_en_ligne",
          "gerer": false,
          "consulter": false,
          "flag": 0,
          "type": "AUT",
          "dateCreation": "2020-05-15T13:15:41.000Z",
          "dateModification": "2023-03-10T15:29:58.000Z",
          "dateSuppression": null,
          "idUsagerCreation": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerModification": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerSuppression": null,
          "isDeleted": false
    }, */}


          {/* {
            "idDroitAccesDetail": "7aef95f1-9813-ef11-b4a1-10f60a435e44",
          "idDroitAcces": "94443d2c-ae96-ea11-b889-80c5f260a79c",
          "description": "permettre_black_list",
          "gerer": true,
          "consulter": true,
          "flag": 0,
          "type": "AUT",
          "dateCreation": "2024-05-16T15:28:29.000Z",
          "dateModification": "2024-05-16T15:28:29.000Z",
          "dateSuppression": null,
          "idUsagerCreation": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerModification": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerSuppression": null,
          "isDeleted": false
    },
          {
            "idDroitAccesDetail": "ce941a84-712e-eb11-b42d-80c5f260a79c",
          "idDroitAcces": "94443d2c-ae96-ea11-b889-80c5f260a79c",
          "description": "POS_config_prix_combo",
          "gerer": true,
          "consulter": true,
          "flag": 0,
          "type": "AUT",
          "dateCreation": "2020-11-24T16:24:25.000Z",
          "dateModification": "2023-03-10T15:29:58.000Z",
          "dateSuppression": null,
          "idUsagerCreation": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerModification": "ffffffff-ffff-ffff-ffff-ffffffffffff",
          "idUsagerSuppression": null,
          "isDeleted": false
    },
          ] */}
          <TabItem title="Autres">
            <Form defaultFormData={DataPermissionAutres} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem caption={"Application"} cssClass="bold-caption">
                <SimpleItem key={"frm-Mise à jour"} dataField={"Mise à jour"} editorType={"dxCheckBox"}
                  editorOptions={
                    miseAJourOptions
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-Copie de sauvegarde"} dataField={"Copie de sauvegarde"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre d'effectuer une copie de sauvegarde des données" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-permettre_mode_formation"} dataField={"permettre_mode_formation"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre le mode formation" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_enregistrement_inactif"} dataField={"modifier_enregistrement_inactif"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de modifier les enregistrements inactifs" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-changer_entreprise"} dataField={"changer_entreprise"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de changer d'entreprise" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_ligne_paiement"} dataField={"modifier_ligne_paiement"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre la prise de paiements en ligne" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Paiements"} cssClass="bold-caption">
                <SimpleItem key={"frm-modifier_date_paiement"} dataField={"modifier_date_paiement"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre la modification de la date d'un paiement" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-??"} dataField={"??"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre la modification d'un paiement enregistré" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-paiement_facture_payee"} dataField={"paiement_facture_payee"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre l'ajout de paiements sur une facture payée" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-changer_usager_paiement"} dataField={"changer_usager_paiement"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de changer l'usager d'un paiement" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Facturation"} cssClass="bold-caption">
                <SimpleItem key={"frm-changer_date_facturation"} dataField={"changer_date_facturation"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de modifier la date de facturation" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_facture_imprimee"} dataField={"modifier_facture_imprimee"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de modifier une facture imprimée" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_ligne_facture_imprime"} dataField={"modifier_ligne_facture_imprime"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre la modification d'un détail de facture imprimée" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_facture_payee"} dataField={"modifier_facture_payee"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre la modification d'une facture payée" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_prix_detail_facture"} dataField={"modifier_prix_detail_facture"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de modifier le prix d'un détail de facture" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-consulter_factures_des_autres_usagers"} dataField={"consulter_factures_des_autres_usagers"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre la consultation des factures des autres usagers" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-mettre_escompte_detail_facture"} dataField={"mettre_escompte_detail_facture"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de mettre un escompte pour un détail de facture" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-transfert_gl_manisoft"} dataField={"transfert_gl_manisoft"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre le transfert manuel au grand livre de Manisoft" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-appliquer_credits_factures"} dataField={"appliquer_credits_factures"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre d'appliquer des crédits sur les factures" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-renversement_facture"} dataField={"renversement_facture"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de renverser une facture" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_details_groupement_produit"} dataField={"modifier_details_groupement_produit"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de modifier les détails de groupement de produits" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_pers_assoc_facture_payee"} dataField={"modifier_pers_assoc_facture_payee"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de modifier les personnes associées même si la facture est payée" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-dissocier_personne_associee"} dataField={"dissocier_personne_associee"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de dissocier une personne associée d'un client" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-afficher_details_ventilation"} dataField={"afficher_details_ventilation"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de visualiser les détails de ventilation" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-delier_facture"} dataField={"delier_facture"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de délier une facture d'une réservation" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-reactiver_estimation_annulee"} dataField={"reactiver_estimation_annulee"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de réactiver une estimation, un bon de travail ou une facture annulée" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Réservations"} cssClass="bold-caption">
                <SimpleItem key={"frm-annuler_reservation"} dataField={"annuler_reservation"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre d'annuler une réservation" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-annuler_reservation_facturee"} dataField={"annuler_reservation_facturee"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre d'annuler une réservation qui a été facturée" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-bloquer_reservation"} dataField={"bloquer_reservation"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de bloquer les réservations" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-changer_prix_detail_reservation"} dataField={"changer_prix_detail_reservation"} editorType={"dxCheckBox"}
                  editorOptions={
                    useMemo(() => {
                      return { text: "Permettre de changer le prix d'un détail de réservation" }
                    }, [])
                  }
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-???"} dataField={"???"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de réactiver les réservations annulées" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-modifier_reservation_facturee"} dataField={"modifier_reservation_facturee"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de modifier une réservation facturée" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-renouveler_reservations"} dataField={"renouveler_reservations"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de renouveler les réservations" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-?"} dataField={"?"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre d'imprimer le calendrier des réservations" }}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Rapports"} cssClass="bold-caption">
                <SimpleItem key={"frm-consulter_rapports_des_autres_postes"} dataField={"consulter_rapports_des_autres_postes"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de consulter les rapports des autres postes d'enregistrement" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-consulter_rapports_preposes"} dataField={"consulter_rapports_preposes"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de consulter les rapports des autres usagers" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-fermer_z"} dataField={"fermer_z"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre la fermeture d'un Z" }}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Enregistrements"} cssClass="bold-caption">
                <SimpleItem key={"frm-dissocier_historique_client"} dataField={"dissocier_historique_client"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de dissocier un client de l'historique des accompagnateurs" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre d'annuler un enregistrement" }}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Contrats"} cssClass="bold-caption">
                <SimpleItem key={"frm-annuler_contrat_avec_facture"} dataField={"annuler_contrat_avec_facture"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre d'annuler un contrat avec facture" }}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Caches"} cssClass="bold-caption">
                <SimpleItem key={"frm-????"} dataField={"????"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de vendre un emplacement de cache à un client n'ayant pas de forfait pour la gestion de cache" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-?????"} dataField={"?????"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de réimprimer une fiche de cache à n'importe quel moment (plutôt que seulement la journée même)" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-??????"} dataField={"??????"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de modifier les caches des années précédentes" }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem key={"frm-???????"} dataField={"???????"} editorType={"dxCheckBox"}
                  editorOptions={{ text: "Permettre de donner ou de retirer le droit acquis d'emplacement d'une cache" }}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Fournisseurs">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                editorOptions={{ text: "Permettre l'accès au module Fournisseur" }}
              >
                <Label visible={false} />
              </SimpleItem>
            </Form>
          </TabItem>
          <TabItem title="Grand-livre">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                editorOptions={{ text: "Permettre l'accès au module Grand-Livre" }}
              >
                <Label visible={false} />
              </SimpleItem>
            </Form>
          </TabItem>
          <TabItem title="Paies">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                editorOptions={{ text: "Permettre l'accès au module Paies" }}
              >
                <Label visible={false} />
              </SimpleItem>
            </Form>
          </TabItem>
          <TabItem title="POS">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem alignItemLabels={false}>
                <SimpleItem key={"frm-description"} dataField={"description"} />
              </GroupItem>
              <SimpleItem key={"maximum-escompte"} dataField={""} editorType={"dxNumberBox"} editorOptions={spinEditorOptions}
              >
                <Label text={"Maximum pourcentage escompte"} />
              </SimpleItem>
              <SimpleItem key={"frm-minimum-escompte"} dataField={""} editorType={"dxNumberBox"} editorOptions={spinEditorOptions}
              >
                <Label text={"Minimum pourcentage escompte"} />
              </SimpleItem>
              <SimpleItem key={"frm-edit-prix"} dataField={"asdf"} editorType={"dxCheckBox"}
                editorOptions={{ text: "Permettre de changer le prix d'un détail de facture" }}
              >
                <Label visible={false} />
              </SimpleItem>
              <SimpleItem key={"frm-delete-paiement"} dataField={"asdf"} editorType={"dxCheckBox"}
                editorOptions={{ text: "Permettre d'effacer un paiement d'une facture imprimée" }}
              >
                <Label visible={false} />
              </SimpleItem>
              <SimpleItem key={"frm-consulter-rapports"} dataField={"asdf"} editorType={"dxCheckBox"}
                editorOptions={{ text: "Permettre de consulter les rapports des autres usagers" }}
              >
                <Label visible={false} />
              </SimpleItem>
            </Form>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem caption={"Accès à la configuration"}>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Mode formation" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section client" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section combos" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section configuration" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section entreprise" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section menu" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section inventaire" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section permissions" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section protection prix" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section prix circulaires" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section prix détails suggérés" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section rapports" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section réclamation sell through" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section sélection d'un warehouse" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section transfert QuickBooks" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section types de paiement" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section usagers" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Section warehouse" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                </Form>
              </div>
              <div style={{ width: "50%" }}>
                <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDroitAcces || {} as IDroitAcces} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem caption={"Accès aux rapports"}>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Rapport X" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Rapport Z" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Rapport journal paiement" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Rapport journal des transactions" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Rapport des réclamations des sell through" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Rapport de protection de prix" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Rapport journal des changements de prix" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={""} dataField={"asdf"} editorType={"dxCheckBox"}
                      editorOptions={{ text: "Génération d'étiquettes" }}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                </Form>
              </div>
            </div>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedDroitAcces || {} as IDroitAcces} /></TabItem>
        </FormListBaseTab>
        : null}
    </FormListBase>
  );
}